/*
 * @Desc: 文件描述
 * @Author: simbawu
 * @Date: 2018-12-29 13:46:49
 * @LastEditors: simbawu
 * @LastEditTime: 2019-07-25 16:42:34
 */
export default {
  // 查看活动
  viewProgress() {
    return this.http('HealthTask', 'get', '/api/v2/balance_activities');
  },

  // 参加活动
  joinIntroduce() {
    return this.http('HealthTask', 'post', '/api/v2/balance_activities');
  },

  // 活动进度
  introduceProgress(id) {
    return this.http(
      'HealthTask',
      'get',
      `/api/v2/balance_activities/${id}`
    );
  },

  // 领取奖励
  receiveReward(params) {
    return this.http(
      'HealthTask',
      'post',
      '/api/v2/balance_activities/receive',
      params
    );
  },

  /**
   * @Desc: 获取饮食记录
   * @Author: simbawu
   */
  getRecordFoods(params) {
    return this.http('HealthTask', 'get', 'api/v2/eatings.json', params);
  }
};
